import { EnvironmentDetail } from '@utils/EnvironmentDetailUtils';
import { BaseCoralHandler } from './BaseCoralHandler';

export class AFTXCoralHandler extends BaseCoralHandler {
    protected static authMethod = 'makeAFTXAjaxRequest';
    protected static authValidator = () => EnvironmentDetail.isAFTXAuthN();
    protected static handlerName = 'AFTXCoralHandler';
}
